module.exports = __webpack_public_path__ + "img/main3.b132470b.png";